<template>
    <div>

        <fieldset>
            <legend>文件加载</legend>
            <div class="param-row">
                <label>Altium Designer 文件:</label>
                <input ref="fileinput" type="file" />
                <input style="display:none;" ref="ncfile" id="ncfile" type="file"  oncancel="console.log('>>>', arguments)"/>
            </div>
            <p class="desc">V割线需要画在 MECHANICAL2层</p>
        </fieldset>

        <div class="row" style="margin-top:20px">
            <div>

                <fieldset>
                    <legend>Mark对点 - 文档位置</legend>
                    <div class="param-row">
                        <label>MARK1 X1:</label>
                        <span>{{marks.doc.x1}}</span>
                    </div>
                    <div class="param-row">
                        <label>MARK1 Y1:</label>
                        <span>{{marks.doc.y1}}</span>
                    </div>
                    <div class="param-row">
                        <label>MARK2 X2:</label>
                        <NumberInput v-model="marks.doc.x2" style="width:100px" @paste-pair="([x, y]) => { marks.doc.x2 = x; marks.doc.y2 = y }" />
                    </div>
                    <div class="param-row">
                        <label>MARK2 Y2:</label>
                        <NumberInput v-model="marks.doc.y2" style="width:100px" @paste-pair="([x, y]) => { marks.doc.x2 = x; marks.doc.y2 = y }" />
                    </div>
                    <div class="param-row">
                        <label>Mark向量:</label>
                        <span>{{ (marks.doc.angle * RAD2DEG).toFixed(3) }}°</span>
                    </div>
                </fieldset>

                <fieldset>
                    <legend>Mark对点 - CNC抄数位置</legend>
                    <div class="param-row">
                        <label>Mark1 X1:</label>
                        <span>{{marks.pcb.x1}}</span>
                    </div>
                    <div class="param-row">
                        <label>Mark1 Y1:</label>
                        <span>{{marks.pcb.y1}}</span>
                    </div>
                    <div class="param-row">
                        <label>Mark2 X2:</label>
                        <NumberInput v-model="marks.pcb.x2" style="width:100px" @paste-pair="([x, y]) => { marks.pcb.x2 = x; marks.pcb.y2 = y }" />
                    </div>
                    <div class="param-row">
                        <label>Mark2 Y2:</label>
                        <NumberInput v-model="marks.pcb.y2" style="width:100px" @paste-pair="([x, y]) => { marks.pcb.x2 = x; marks.pcb.y2 = y }" />
                    </div>
                    <div class="param-row">
                        <label>Mark向量:</label>
                        <span>{{ (marks.pcb.angle * RAD2DEG).toFixed(3) }}°</span>
                    </div>
                    <div class="param-row">
                        <label>PCB偏转:</label>
                        <span>{{ ((marks.pcb.angle-marks.doc.angle) * RAD2DEG).toFixed(3) }}°</span>
                    </div>
                </fieldset>

                <fieldset>
                    <legend>预览</legend>
                    <div class="param-row">
                        <label>图层:</label>
                        <select v-model="layer">
                            <option value="top">顶层（正面）</option>
                            <option value="bottom">底层（反面）</option>
                        </select>
                    </div>
                    <button @click="draw">预览</button>
                </fieldset>

                <fieldset>
                    <legend>NC后处理</legend>
                    <div class="param-row">
                        <label>V割深度:</label>
                        <NumberInput v-model="cutdepth" style="width:60px" />
                        <span class="hint">mm (一般为板厚的1/3)</span>
                    </div>
                    <div class="param-row">
                        <label>主轴转速:</label>
                        <NumberInput v-model="toolRPM" style="width:60px" />
                        <span class="hint">RPM</span>
                    </div>
                    <div class="param-row">
                        <label>下刀进给:</label>
                        <NumberInput v-model="feedDown" style="width:60px" />
                        <span class="hint">mm/min</span>
                    </div>
                    <div class="param-row">
                        <label>切割进给:</label>
                        <NumberInput v-model="feedCut" style="width:60px" />
                        <span class="hint">mm/min</span>
                    </div>
                    <button @click="generateNC">后处理</button>
                </fieldset>

            </div>

            <div style="text-align: center;" class="grow">
                <canvas
                    ref="canvas"
                    :width="CanvasW"
                    :height="CanvasH"
                    style="width: 800px; height: 600px"
                ></canvas>
            </div>

        </div>
    </div>
</template>

<script>
import { ref, reactive, inject } from "vue";
import { readFileAsText } from "../util/browser-fs.js";
import NumberInput from "./NumberInput.vue";

// const CanvasMargin = 20
const CanvasW = 800
const CanvasH = 600
// const ContentW = CanvasW - 2*CanvasMargin
// const ContentH = CanvasH - 2*CanvasMargin
const RAD2DEG = 180/Math.PI
const DEG2RAD = Math.PI/180

export default {
    name: "VCut",
    components: { NumberInput },

    setup() {
        const fileManager = inject("fileManager");

        return {
            lines: reactive([]),
            board: reactive({
                top: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                } ,
                bottom: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                } ,
                origin: {
                    x:0, y:0
                }
            }),
            layer: ref("top"),
            marks: reactive({
                doc: {x1:0,y1:0,x2:1,y2:1,angle: Math.PI/4} ,
                pcb: {x1:0,y1:0,x2:1,y2:1,angle: Math.PI/4} ,
            }) ,
            ctx: null,
            CanvasW, CanvasH, RAD2DEG, DEG2RAD,

            toolRPM: 12000,
            cutdepth: 0.1 ,
            feedDown: 100,
            feedCut: 300,

            fileinput:ref(null), canvas: ref(null), ncfile:ref(null),
            fileManager,
        };
    },

    mounted() {
        this.ctx = this.canvas.getContext("2d");

    } ,

    methods: {
        async loadDoc() {
            console.log(this.$refs)
            if (!this.$refs.fileinput.files[0]) {
                console.log("not select ad doc file");
                alert("请选择文件");
                return false;
            }
            let docstr
            try {
                docstr = await readFileAsText(this.$refs.fileinput)
            } catch(e) {
                alert("读取文件失败：" + e.message)
                console.error(e)
                return false
            }


            this.board.origin.x = 0
            this.board.origin.y = 0
            this.lines.length = 0;

            let lines = docstr.split("\n")

            for (let line of lines) {
                // 原点位置
                let res = line.match(/\|RECORD=Board\|.*\|ORIGINX=(\d+\.\d+mil)\|ORIGINY=(\d+\.\d+mil)\|/)
                if(res) {
                    console.log("---> origin in pcb:", res)
                    this.board.origin.x = parseNum(res[1])
                    this.board.origin.y= parseNum(res[2])
                    break
                }
            }

            for (let line of lines) {
                let comp = parseLine(line, this.board.origin);
                if (!comp) {
                    continue;
                }
                if (comp.LAYER == "MECHANICAL2") {
                    this.lines.push(comp);
                } else {
                    continue;
                }
            }
            console.log("board:",this.board);
            console.log("lines:",this.lines);
            return true
        },

        calculateAngle() {

            // 计算pcb在cnc上摆放的角度
            let docx = this.marks.doc.x2 - this.marks.doc.x1
            let docy = this.marks.doc.y2 - this.marks.doc.y1
            let pcbx = this.marks.pcb.x2 - this.marks.pcb.x1
            let pcby = this.marks.pcb.y2 - this.marks.pcb.y1
            this.marks.doc.angle = Math.atan(docy/docx)
            this.marks.pcb.angle= Math.atan(pcby/pcbx)
        } ,

        offsetBoard(offset_rad) {
            this.board.top.x1 = NaN;
            this.board.top.y1 = NaN;
            this.board.top.x2 = NaN;
            this.board.top.y2 = NaN;
            this.board.bottom.x1 = NaN;
            this.board.bottom.y1 = NaN;
            this.board.bottom.x2 = NaN;
            this.board.bottom.y2 = NaN;

            for (let comp of this.lines) {

                // 正面偏转位置
                [comp.ofrom.top.x, comp.ofrom.top.y] = rotateVector(comp.x1,comp.y1, offset_rad);
                [comp.oto.top.x, comp.oto.top.y] = rotateVector(comp.x2,comp.y2, offset_rad);
                this.expandBoard(comp, "top");

                // 反面定位
                [comp.ofrom.bottom.x, comp.ofrom.bottom.y] = rotateVector(-comp.x1,comp.y1, offset_rad);
                [comp.oto.bottom.x, comp.oto.bottom.y] = rotateVector(-comp.x2,comp.y2, offset_rad);
                this.expandBoard(comp, "bottom")

            }
            console.log("board:",this.board);
            console.log("lines:",this.lines);
        } ,

        expandBoard(comp, layer) {
                let x1 = Math.min(comp.ofrom[layer].x, comp.oto[layer].x)
                let x2 = Math.max(comp.ofrom[layer].x, comp.oto[layer].x)
                let y1 = Math.min(comp.ofrom[layer].y, comp.oto[layer].y)
                let y2 = Math.max(comp.ofrom[layer].y, comp.oto[layer].y)

                if ( isNaN(this.board[layer].x1) || x1 < this.board[layer].x1 ) {
                    this.board[layer].x1 = x1;
                }
                if ( isNaN(this.board[layer].x2) || x2 > this.board[layer].x2) {
                    this.board[layer].x2 = x2;
                }
                if ( isNaN(this.board[layer].y1) || y1 < this.board[layer].y1) {
                    this.board[layer].y1 = y1;
                }
                if ( isNaN(this.board[layer].y2) || y2 > this.board[layer].y2) {
                    this.board[layer].y2 = y2;
                }
        } ,


        async draw() {

            if(!(await this.loadDoc())) {
                return
            }

            this.calculateAngle()

            this.offsetBoard( this.marks.pcb.angle - this.marks.doc.angle )

            // 重置 canvas
            this.$refs.canvas.width = this.$refs.canvas.width
            this.$refs.canvas.height = this.$refs.canvas.height

            let scale = this.scale()
            console.log("scale:",scale)

            // 居中显示
            let  offsetx = (CanvasW - (this.board[this.layer].x2-this.board[this.layer].x1)*scale)/2 - this.board[this.layer].x1
            let offsety = (CanvasH - (this.board[this.layer].y2-this.board[this.layer].y1)*scale)/2
            console.log("canvas offset: ", offsetx, offsety, this.board)

            if(this.layer=="top") {
                this.ctx.translate(offsetx, offsety+CanvasH+this.board[this.layer].y1*scale)
            }
            else {
                this.ctx.translate(CanvasW-offsetx, offsety+CanvasH+this.board[this.layer].y1*scale)
            }

            this.$refs.canvas;
            this.ctx.beginPath()
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = "#333";
            for (let line of this.lines) {
                this.drawLine(line, scale);
            }

            this.drawMarks()

            // 坐标轴
            this.drawAxies(70)
        },

        drawLine(comp, scale) {
            this.ctx.moveTo(comp.ofrom[this.layer].x*scale,-comp.ofrom[this.layer].y*scale);
            this.ctx.lineTo(comp.oto[this.layer].x*scale,-comp.oto[this.layer].y*scale);
            this.ctx.stroke();
        },

        drawMarks() {

        } ,

        drawAxies(l) {
            this.ctx.beginPath()
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = "red";
            this.ctx.moveTo(-l,0);
            this.ctx.lineTo(l,0);
            this.ctx.moveTo(0,-l);
            this.ctx.lineTo(0,l);
            this.ctx.stroke();
        } ,

        drawBoard(scale) {
            this.ctx.moveTo(1,1)
            this.ctx.lineTo(1,(this.board.oy2-this.board.oy1)*scale-1)
            this.ctx.lineTo((this.board.ox2-this.board.ox1)*scale+1,(this.board.oy2-this.board.oy1)*scale-1)
            this.ctx.lineTo((this.board.ox2-this.board.ox1)*scale+1,1)
            this.ctx.lineTo(1,1)
            this.ctx.stroke();
        } ,

        scale() {
            let width = this.board[this.layer].x2 - this.board[this.layer].x1
            let height = this.board[this.layer].y2 - this.board[this.layer].y1

            if( (width/CanvasW) > (height/CanvasH) ) {
                return CanvasW/width
            }
            else {
                return CanvasH/height
            }
        } ,

        generateNC() {

            let pos = [0,0]
            let lines = this.lines.slice(0)
            // console.log(lines)

            this.cutdepth = parseFloat(this.cutdepth)
            if(isNaN(this.cutdepth)) {
                alert("切割深度无效")
                return
            }

            // let ox = isNaN(this.board.origin.x)? 0: this.board.origin.x
            // let oy = isNaN(this.board.origin.y)? 0: this.board.origin.y

            // console.log("board origin", this.board.origin)

            let nc = `%
	G90 G54
	G0 X0 Y0 Z10 S${this.toolRPM} M03
	`
            let nc_inv = nc

            let originOffset = NaN
            while (lines.length>0) {
                let line = this.fetchNearestLine(pos, lines, originOffset)
                if(!line) {
                    break
                }
                // if(isNaN(originOffset)) {
                //     originOffset = line[0]
                // }
                // console.log(line)
                nc+= `G0 X${line.from.top.x.toFixed(3)} Y${line.from.top.y.toFixed(3)}
	G0 Z0.5
	G1 Z-${this.cutdepth} F${this.feedDown}
	G1 X${line.to.top.x.toFixed(3)} Y${line.to.top.y.toFixed(3)} F${this.feedCut}
	G0 Z10
	`
                nc_inv+= `G0 X${line.from.bottom.x.toFixed(3)} Y${line.from.bottom.y.toFixed(3)}
	G0 Z0.5
	G1 Z-${this.cutdepth} F${this.feedDown}
	G1 X${line.to.bottom.x.toFixed(3)} Y${line.to.bottom.y.toFixed(3)} F${this.feedCut}
	G0 Z10
	`

                pos = [line.next.x, line.next.y]
            }

            const inputFile = this.$refs.fileinput.files[0]
            if(!inputFile) {
                alert("还没有选择Altium源文件")
                return
            }
            const inputName = inputFile.name
            const newFilename = inputName.replace(/\.[^.]+$/, '-正面.nc')
            const newFilenameInv = inputName.replace(/\.[^.]+$/, '-反面.nc')

            // 将正反面 NC 文件添加到文件面板
            this.fileManager.addFileTab(newFilename, nc)
            this.fileManager.addFileTab(newFilenameInv, nc_inv)
        } ,

        fetchNearestLine(pos, list) {
            // if(isNaN(oo))
            //     oo = [0,0]
            let nearest = {
                from: null ,
                to: null ,
                next: {x:NaN, y:NaN}
            }
            let neardis = -1
            let nearestIndex = -1
            for(let l=0;l<list.length;l++) {
                let line = list[l]
                let dis1 = (line.x1-pos[0])*(line.x1-pos[0]) + (line.y1-pos[1])*(line.y1-pos[1])
                let dis2 = (line.x2-pos[0])*(line.x2-pos[0]) + (line.y2-pos[1])*(line.y2-pos[1])
                if(dis2<dis1) {
                    if(neardis>-1 && dis2>neardis)
                        continue
                    nearest.from = line.oto
                    nearest.to = line.ofrom
                    nearest.next.x = line.x1
                    nearest.next.y = line.y1
                    neardis = dis2
                    nearestIndex = l
                }
                else {
                    if(neardis>-1 && dis1>neardis)
                        continue
                    nearest.from = line.ofrom
                    nearest.to = line.oto
                    nearest.next.x = line.x2
                    nearest.next.y = line.y2
                    neardis = dis1
                    nearestIndex = l
                }
            }

            if(neardis>-1) {
                list.splice(nearestIndex,1)
                return nearest
            }
            else {
                console.error("未能找到最近的直线:", pos, list)
            }
        }
    },
}

function parseLine(linestr, origin) {
    linestr = (linestr || "").trim();
    let items = {};
    for (let itemstr of linestr.match(/[^\|]+?\|/g) || []) {
        let item = itemstr.match(/([^=]+)=([^\|]+)\|/s);
        if (item) {
            items[item[1]] = item[2];
        }
    }

    if (
        items.RECORD != "Track" ||
        !items.X1 ||
        !items.X2 ||
        !items.Y1 ||
        !items.Y2
    ) {
        return;
    }

    let X1 = parseNum(items.X1)
    let X2 = parseNum(items.X2)
    let Y1 = parseNum(items.Y1)
    let Y2 = parseNum(items.Y2)

    return {
        LAYER: items.LAYER,

        // 原始坐标值 (mil)
        _x1: items.X1,
        _x2: items.X2,
        _y1: items.Y1,
        _y2: items.Y2,

        // pcb原点坐标值 (mm)
        x1: X1 - origin.x,
        x2: X2 - origin.x,
        y1: Y1 - origin.y,
        y2: Y2 - origin.y,

        // 正反面偏转后的
        ofrom: {
            top: {x:NaN, y:NaN} ,
            bottom: {x:NaN, y:NaN} ,
        } ,
        oto: {
            top: {x:NaN, y:NaN} ,
            bottom: {x:NaN, y:NaN} ,
        } ,
    };
}

function parseNum(numstr) {
    let res = numstr.match(/^(\d+\.\d+)mil$/i);
    if (!res) {
        return 0;
    }
    return parseFloat(res[1]) * 0.0254;
}

function rotateVector(x,y,rad) {
    return [
        x * Math.cos(rad) - y*Math.sin(rad),
        x * Math.sin(rad) + y*Math.cos(rad)
    ]
}
</script>

<style>
</style>
